import { Component, Input, Output, EventEmitter, AfterViewInit, OnDestroy, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

interface PrecreditToogleOption {
  label?: string;
  logo?: string;
  value: string;
}

@Component({
  selector: 'app-precredit-toogle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './precredit-toogle.component.html',
  styleUrls: ['./precredit-toogle.component.scss']
})
export class PrecreditToogleComponent implements AfterViewInit, OnDestroy {
  @Input() firstOption: PrecreditToogleOption = { label: 'Desktop', logo: 'fi fi-rr-computer', value: 'desktop' };
  @Input() secondOption: PrecreditToogleOption = { label: 'Mobile', logo: 'fi fi-rr-smartphone', value: 'mobile' };

  @Output() optionChanged = new EventEmitter<string>();

  @ViewChild('container', { static: false }) container!: ElementRef<HTMLDivElement>;
  @ViewChild('slider', { static: false }) slider!: ElementRef<HTMLDivElement>;
  @ViewChild('btnFirst', { static: false }) btnFirst!: ElementRef<HTMLButtonElement>;
  @ViewChild('btnSecond', { static: false }) btnSecond!: ElementRef<HTMLButtonElement>;

  selectedMode: 'first' | 'second' = 'first';

  private resizeObserver: ResizeObserver | null = null;
  private initTimerId: number | null = null;

  ngAfterViewInit(): void {
    this.syncSlider();
    this.observeSize();
    this.initTimerId = window.setTimeout(() => {
      this.initTimerId = null;
      this.setMode('first');
    }, 50);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
    if (this.initTimerId !== null) {
      window.clearTimeout(this.initTimerId);
      this.initTimerId = null;
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.syncSlider();
  }

  setMode(mode: 'first' | 'second'): void {
    this.selectedMode = mode;

    if (mode === 'first') {
      this.moveSlider(this.btnFirst.nativeElement);
      this.optionChanged.emit(this.firstOption.value);
    } else {
      this.moveSlider(this.btnSecond.nativeElement);
      this.optionChanged.emit(this.secondOption.value);
    }
  }

  private observeSize(): void {
    if (typeof ResizeObserver === 'undefined') return;
    this.resizeObserver = new ResizeObserver(() => this.syncSlider());
    [this.container, this.btnFirst, this.btnSecond].forEach((ref) => {
      if (ref?.nativeElement) this.resizeObserver?.observe(ref.nativeElement);
    });
  }

  private syncSlider(): void {
    const active = this.selectedMode === 'first' ? this.btnFirst : this.btnSecond;
    if (active?.nativeElement) this.moveSlider(active.nativeElement);
  }

  private moveSlider(targetBtn: HTMLButtonElement): void {
    if (!this.slider || !targetBtn || targetBtn.offsetWidth === 0) return;
    this.slider.nativeElement.style.width = targetBtn.offsetWidth + 'px';
    this.slider.nativeElement.style.left = targetBtn.offsetLeft + 'px';
  }

  isFirstSelected(): boolean {
    return this.selectedMode === 'first';
  }

  isSecondSelected(): boolean {
    return this.selectedMode === 'second';
  }
}
